export const handleHeightFocus = (e: React.FocusEvent<HTMLInputElement>) => {
  if (e.target.value.trim() === '0') {
    e.target.value = '';
  }
};
